import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["display"];
  static values = { lockedAt: String, duration: Number };

  connect() {
    this.update();
    this.timer = setInterval(() => this.update(), 1000);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  update() {
    const expiresAt = new Date(this.lockedAtValue).getTime() + this.durationValue * 1000;
    const remaining = Math.max(0, Math.floor((expiresAt - Date.now()) / 1000));

    if (remaining <= 0) {
      clearInterval(this.timer);
      this.displayTarget.textContent = "Unlocked.";
      return;
    }

    const minutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;
    this.displayTarget.textContent = minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;
  }
}
